<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
></app-table-header>
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="users-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px">#ID</th>
      <th nzColumnKey="avatar" nzWidth="100px"></th>
      <th nzColumnKey="firstName" [nzSortFn]="true">Vorname</th>
      <th nzColumnKey="lastName" [nzSortFn]="true">Nachname</th>
      <th nzColumnKey="position" [nzSortFn]="true">Berufsbezeichnung</th>
      <th nzColumnKey="login" [nzSortFn]="true">Benutzername</th>
      <th nzColumnKey="email" [nzSortFn]="true">E-Mail</th>
      <th nzColumnKey="role" [nzFilters]="filterRoles" [nzFilterFn]="true" [nzSortFn]="true">Rolle</th>
      <th nzColumnKey="actions" nzRight nzWidth="130px"></th>
    </tr>
  </thead>
  <tbody>
    @for (user of data.results; track user) {
      <tr>
        <td>{{user.id}}</td>
        <td>
          <app-avatar
            [sizePx]="30"
            [fullName]="{ firstName: user.firstName, lastName: user.lastName }"
          ></app-avatar>
        </td>
        <td>{{user.firstName}}</td>
        <td>{{user.lastName}}</td>
        <td>{{user.position}}</td>
        <td>{{user.login}}</td>
        <td>{{user.email}}</td>
        <td>{{user.role | roleLabel}}</td>
        <td nzRight>
          <div class="actions">
            <app-add-edit-modal (refresh)="onRefreshList(false)" #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Mitarbeiter bearbeiten: ' + user.lastName"
                  (pressed)="modal.showModal(user)"
                ></app-icon-button>
              </span>
            </app-add-edit-modal>
            @if (user.documentKey) {
              <app-download-document [documentKey]="user.documentKey" class="left-space" icon="printer" tooltipTitle="Abzeichen drucken"></app-download-document>
            }
            <app-icon-button
              icon="delete"
              [ariaLabel]="'Mitarbeiter löschen: ' + user.lastName"
              confirmTitle="Sind Sie sicher?"
              (confirmed)="deleteElement(user.id)"
            ></app-icon-button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
